import { render, staticRenderFns } from "./AdminWorkspacesFromClients.vue?vue&type=template&id=c670a33e&scoped=true"
import script from "./AdminWorkspacesFromClients.vue?vue&type=script&lang=ts"
export * from "./AdminWorkspacesFromClients.vue?vue&type=script&lang=ts"
import style0 from "./AdminWorkspacesFromClients.vue?vue&type=style&index=0&id=c670a33e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c670a33e",
  null
  
)

export default component.exports